module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/_cache/bio2-4.vue");


//////////////////
// WEBPACK FOOTER
// ./src/assets/md/bio2.md
// module id = 213
// module chunks = 0